import {connect} from "react-redux";
import WaterPalletsPage from "./WaterPalletsPage";
import * as InventoryApiActions from "../../actions/InventoryApiActions";
import * as ViewActions from "../../actions/ViewActions";

function mapStateToProps(state) {
  return {
  }
}

export default connect(mapStateToProps, {...InventoryApiActions, ...ViewActions})(WaterPalletsPage);